import React from 'react';
import { useState, useEffect} from 'react';
import ViewInspectors from 'components/Inspectors/ViewInspectors';
import ViewCompliance from 'components/Compliance/ViewCompliance';

import axios from 'axios'

import { 
  LayoutDashboard, 
  DollarSign, 
  CreditCard, 
  PieChart, 
  Users, 
  Activity,
  Newspaper,
  Video,
  Settings,
  ChevronLeft,
  ChevronRight,
  Home,
  LogOut
} from 'lucide-react';
import { NavLink, useNavigate } from 'react-router-dom';

const AdminSidebar = ({ collapsed, onToggle }) => {
  const navigate = useNavigate();
  const [userroles, setUserroles] = useState("");
  const [loading, setLoading] = useState(true);

  const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL
  });

  // Add token to all requests
  api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token'); // or wherever you store your token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if(!token){
      navigate('/');
    }
    return config;
  });


  

  const GetUserroles = async () => {
    try {
      setLoading(true);
      const response = await api.get('/userroles');
      // FIXED: Use response.data instead of response.json()
      const data = response.data;  // ← THIS WAS THE ERROR
      setUserroles(data.userrole); // Also fixed: data.userrole (not data.userroles)
      console.log('sidebar user roles is :', data.userrole);
    } catch (error) {
      console.error('Error fetching user role:', error);
      if (error.response?.status === 401) {
        console.log('User not authenticated - redirect to login');
        // navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    GetUserroles();
  }, []);

  // Menu items for Admin
  console.log('Rendering AdminSidebar with user role:', userroles);
  const menuItems = [
    { name: 'Dashboard', icon: LayoutDashboard, path: '/admin/dashboard' },
    { name: 'Traders', icon: DollarSign, path: '/admin/viewtrader' },
    { name: 'Inspections', icon: CreditCard, path: '/admin/viewinspection' },
    { name: 'Inspectors', icon: PieChart, path: '/admin/viewinspectors' },
    { name: 'File', icon: Users, path: '/admin/viewfile' },
    { name: 'Compliance', icon: Activity, path: '/admin/ViewCompliance' },
    { name: 'Users', icon: Newspaper, path: '/admin/viewuser' },
  ];

  // Menu items for Inspectors
  const Inspectormenu = [
    { name: 'Dashboard', icon: LayoutDashboard, path: '/admin/dashboard' },
    { name: 'Traders', icon: DollarSign, path: '/admin/InspectorViewtrader' },
    { name: 'Inspections', icon: CreditCard, path: '/admin/inspectorviewinspection' },
    { name: 'Myfile', icon: Users, path: '/admin/InspectorViewfile' },
    { name: 'compliances', icon: Activity, path: '/admin/insepectorcomliance' },
  ];

  // Menu items for regular user
  const Usermenu = [
    { name: 'Dashboard', icon: LayoutDashboard, path: '/admin/dashboard' },
   
    { name: 'My File', icon: Users, path: '/admin/userviewfile' },
    { name: 'Compliance', icon: Activity, path: '/admin/UserCompliance' },
  ];

    const Tradermenu = [
    { name: 'Dashboard', icon: LayoutDashboard, path: '/admin/dashboard' },
    { name: 'Myinspections', icon: CreditCard, path: '/admin/traderinspection' },
    { name: 'My File', icon: Users, path: '/admin/userviewfile' },
    { name: 'Compliance', icon: Activity, path: '/admin/UserCompliance' },
  ];



    
   if (loading) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center">
     
        <h3 className="mt-6 text-xl font-semibold text-gray-800">Loading...</h3>
        
        
       
      </div>
    
  );
}


  // Select menu based on role
  let activeMenu = Usermenu; // default
  if (userroles === 'admin') {
    activeMenu = menuItems;
  } else if (userroles === 'inspector') {
    activeMenu = Inspectormenu;
  }
  else if(userroles==='trader'){
    activeMenu = Tradermenu
  }

  // Single return with dynamic menu
  return (
    <aside className={`fixed left-0 top-0 h-full bg-indigo-700 text-white shadow-xl transition-all duration-300 z-30 ${collapsed ? 'w-20' : 'w-64'}`}>
      {/* Logo Section */}
      <div className="flex items-center justify-between p-6 border-b border-indigo-600">
        <div className={`flex items-center gap-3 ${collapsed ? 'justify-center w-full' : ''}`}>
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
            <Home className="w-6 h-6 text-white" />
          </div>
          {!collapsed && (
            <div>
              <h1 className="text-xl font-bold text-white">ETIMS</h1>
              <p className="text-xs text-indigo-200">ETIMS v1.0</p>
            </div>
          )}
        </div>
        {!collapsed && (
          <button
            onClick={onToggle}
            className="p-2 rounded-lg hover:bg-indigo-600 transition-colors"
          >
            <ChevronLeft className="w-5 h-5 text-white" />
          </button>
        )}
        {collapsed && (
          <button
            onClick={onToggle}
            className="p-2 rounded-lg hover:bg-indigo-600 transition-colors mt-2"
          >
            <ChevronRight className="w-5 h-5 text-white" />
          </button>
        )}
      </div>

      {/* Menu Items */}
      <nav className="p-4 flex-1 overflow-y-auto">
        <ul className="space-y-2">
          {activeMenu.map((item) => (
            <li key={item.name}>
              <NavLink
                to={item.path}
                className={({ isActive }) => 
                  `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${
                    isActive
                      ? 'bg-blue-500 text-white shadow-lg'
                      : 'text-indigo-100 hover:bg-indigo-600 hover:text-white'
                  } ${collapsed ? 'justify-center' : ''}`
                }
                end
              >
                <item.icon className="w-5 h-5" />
                {!collapsed && <span>{item.name}</span>}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Bottom Section - Logout */}
      
    </aside>
  );
};

export default AdminSidebar;